import type { FirestoreTenantProfile } from "~/services/server/user-tenant/getTenantInfo";

export interface FirestoreTenantProfileDisplay {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  profilePictureUrl?: string;
}

export function mapFirestoreTenantProfileToDisplay(
  profile: FirestoreTenantProfile | null | undefined
): FirestoreTenantProfileDisplay | null {
  if (!profile) return null;
  return {
    username: profile.username,
    firstName: profile.firstName,
    lastName: profile.lastName,
    email: profile.email,
    profilePictureUrl: profile.profilePictureUrl,
  };
}
